module.exports = __webpack_public_path__ + "static/media/lowfat.e214f3e7.jpg";